import { AxiosResponse } from "axios";
import { fork, put, takeLatest } from "redux-saga/effects";
import { EPAWorklistCount } from "../../Apis/AuthApiServices";
import {
  loadingEPAWorklistCount,
  setEPAWorklistCount,
} from "../Slice/EPAWorklistCountSlice";

function* onLoadEPAWorklistCountAsync({ payload }: any) {
  const params = new URLSearchParams();
  let doctorId: any = localStorage.getItem("doctorId");
  params.append("doctorId", doctorId);
  params.append("pageNumber", payload.pageNumber);
  params.append("pageSize", payload.pageSize);
  params.append("prescriptionType", payload.prescriptionType);
  try {
    const result: AxiosResponse = yield EPAWorklistCount(params);
    if (result?.data?.digitalRxStatusCode === 200) {
      yield put(
        setEPAWorklistCount({
          EPAWorklistCountData: result?.data?.response,
          Items: result?.data?.response[0]?.items,
          Pagination: result?.data?.response[0]?.pagination,
          isLoading: false,
          error: false,
        })
      );
    } else {
      yield put(
        setEPAWorklistCount({
          EPAWorklistCountData: [],
          error: false,
          isLoading: false,
          message: result?.data?.digitalRxStatusMessage,
        })
      );
    }
  } catch (error: any) {
    yield put(
      setEPAWorklistCount({
        EPAWorklistCountData: [],
        error: true,
        isLoading: false,
        message: "Try Again After Some Time!",
      })
    );
  }
}

function* onLoadEPAWorklistCount() {
  yield takeLatest(loadingEPAWorklistCount.type, onLoadEPAWorklistCountAsync);
}

const EPAWorklistCountSaga = [fork(onLoadEPAWorklistCount)];
export default EPAWorklistCountSaga;
